"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useDismissable;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useDismissable(namespace, key) {
  var localStorageKey = namespace && key && "".concat(namespace, "/").concat(key);
  var _useState = (0, _react.useState)(function () {
      if (localStorage && localStorageKey) {
        return localStorage.getItem(localStorageKey) === 'true';
      } else {
        return false;
      }
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dismissed = _useState2[0],
    setDismissed = _useState2[1];
  (0, _react.useEffect)(function () {
    if (localStorageKey) {
      localStorage && localStorage.setItem(localStorageKey, dismissed.toString());
    }
  }, [localStorageKey, dismissed]);
  function setAsDismissed() {
    setDismissed(true);
  }
  return [dismissed, setAsDismissed];
}